export default {
    "de": {
        "username": "Benutzername / E-Mail",
        "password": "Passwort",
        "login": "Anmelden",
        "request_password": "Passwort vergessen",
        
        "errors": {
            "invalid_grant": "Die angegebenen Login-Daten sind ungültig.",
            "invalid_request": "Ungültiger Anmeldeversuch."
        }
    }
}